import { createContext, useLayoutEffect, useState } from "react";
import { useSelector } from "../store";

export const PermissionContext = createContext({});

export const PermissionProvider = ({ children }) => {

    const { member_permission } = useSelector((state) => state.account)

    const NumbersSettingGuard = () => {
        const isWriteAllowed = member_permission["numbers_is_edit_setting"]
        return isWriteAllowed;
    };

    const WriteAgentGuard = () => {
        const isWriteAllowed = member_permission["assistants_is_create_agent"]
        return isWriteAllowed;
    }

    const BuySubscriptionGuard = () => {
        const isWriteAllowed = member_permission["subscription_is_purchase_subscription"]
        return isWriteAllowed;
    }

    const CreateApiKeyGuard = () => {
        const isWriteAllowed = member_permission["api_key_is_create_key"]
        return isWriteAllowed;
    }

    const InviteMemberInOrg = () => {
        const isWriteAllowed = member_permission["organization_is_invite_member"]
        return isWriteAllowed;
    }

    const EditMemberInOrg = () => {
        const isWriteAllowed = member_permission["organization_is_edit_member"]
        return isWriteAllowed;
    }

    const EditOrgSetting = () => {
        const isWriteAllowed = member_permission["organization_is_edit_setting"]
        return isWriteAllowed;
    }

    const ReadObcGuard = () => {
        const isReadAllowed = member_permission["outbound_call_is_view_obc"];
        return isReadAllowed;
    }

    const WriteObcGuard = () => {
        const isWriteAllowed = member_permission["outbound_call_is_create_obc"];
        return isWriteAllowed;
    }

    const StartObcGuard = () => {
        const isWriteAllowed = member_permission["outbound_call_is_start_call"];
        return isWriteAllowed;
    }

    const ReadKnowledgeBaseGuard = () => {
        const isReadAllowed = member_permission["knowledge_base_is_view_knowledge_base"];
        return isReadAllowed;
    }

    const WriteKnowledgeBaseGuard = () => {
        const isWriteAllowed = member_permission["knowledge_base_is_create_knowledge_base"];
        return isWriteAllowed;
    }

    return (
        <PermissionContext.Provider
            value={{
                NumbersSettingGuard,
                WriteAgentGuard,
                BuySubscriptionGuard,
                CreateApiKeyGuard,
                InviteMemberInOrg,
                EditMemberInOrg,
                EditOrgSetting,
                WriteObcGuard,
                StartObcGuard,
                ReadObcGuard,
                ReadKnowledgeBaseGuard,
                WriteKnowledgeBaseGuard
            }}
        >
            {children}
        </PermissionContext.Provider>
    );
};
